import { Link } from 'react-router-dom';
import { site, stats } from '@/mocks/site';

export default function HomeHero() {
  return (
    <section id="top" className="relative w-full h-[600px] md:h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Moody%20dark%20theater%20stage%20with%20warm%20amber%20spotlight%20beams%20cutting%20through%20haze%2C%20deep%20terracotta%20velvet%20curtains%2C%20empty%20seats%20in%20shadow%2C%20cinematic%20editorial%20photography%2C%20rich%20coral%20and%20gold%20tones%2C%20dramatic%20atmospheric%20depth&width=1800&height=1000&seq=chigua-hero-main&orientation=landscape"
        alt="暖光舞台与剧场氛围，象征福利吃瓜的档期内容现场"
        title="福利吃瓜 - 按档期追更娱乐热点"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/25 to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 text-xs md:text-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            今日上新 · 本周推荐 · 周末限定 · 假日特辑
          </span>
          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight md:leading-tight">
            福利吃瓜，不错过
            <br />
            任何一场精彩好戏
          </h1>
          <p className="mt-5 text-sm md:text-lg text-background-100/90 leading-7 md:leading-8 max-w-2xl">
            {site.intro}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
              进入瓜料库
            </Link>
            <Link
              to="/topics?cat=today"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              先看今日上新
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-2xl">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="font-heading text-xl md:text-2xl font-bold text-accent-400">{s.value}</dt>
                <dd className="mt-1 text-xs md:text-sm text-background-200/90">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}